var map = {
	"./abstract/arrow-left.svg": 2152,
	"./abstract/arrow-right.svg": 8471,
	"./abstract/arrow.svg": 7806,
	"./abstract/checkmark.svg": 1818,
	"./abstract/chevron-top.svg": 4102,
	"./abstract/chevron.svg": 156,
	"./abstract/circle.svg": 3031,
	"./abstract/corousel-left-arrow.svg": 6627,
	"./abstract/corousel-right-arrow.svg": 5734,
	"./abstract/download-arrow.svg": 6107,
	"./abstract/flag-uk.svg": 2753,
	"./abstract/hero-pointer.svg": 6699,
	"./abstract/loupe.svg": 2680,
	"./abstract/menu-close.svg": 1317,
	"./abstract/play-button.svg": 226,
	"./abstract/quote.svg": 3681,
	"./abstract/search.svg": 5151,
	"./abstract/star.svg": 4983,
	"./score-circles/blue-circle.svg": 8844,
	"./score-circles/gray-circle.svg": 3483,
	"./signs/checkmark.svg": 7433,
	"./signs/cross.svg": 3841,
	"./signs/warning.svg": 1637,
	"./social/angel-co-logo.svg": 9500,
	"./social/logo-facebook.svg": 5840,
	"./social/logo-linkedin.svg": 2882,
	"./social/logo-x.svg": 5212,
	"./social/logo-youtube.svg": 2151,
	"./social/medium-logo.svg": 7701,
	"./social/website-logo.svg": 7679,
	"./templates/blue-bg-checkmark.svg": 3330,
	"./templates/blue-rectangle.svg": 4810,
	"./templates/board_view_small.svg": 6938,
	"./templates/chart_view_small.svg": 9414,
	"./templates/experts.svg": 6357,
	"./templates/hierarchy_small.svg": 2175,
	"./templates/inbox_view_small.svg": 6914,
	"./templates/pencil.svg": 7277,
	"./templates/star.svg": 302,
	"./templates/table_view_small.svg": 9222,
	"./templates/timeline_view_small.svg": 2553,
	"./templates/white-rectangle.svg": 6997
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6046;